import axios from "axios";

export default axios.create({
  baseURL: "https://wash-lucidity.mparatsas.gr",
});
